const probes = new Map<string, Promise<unknown>>();

const KEEP_MS = 8000;

/**
 * The machine guard and the path gate share one probe. The promise stays for a
 * few seconds so the gate, which mounts after the guard, does not repeat the
 * GETs. Session writes and application writes must call `invalidatePathProbe`
 * or this window would keep a result from before the write.
 */
export function readPathProbe<T>(quoteId: string): Promise<T> | undefined {
  return probes.get(quoteId.trim()) as Promise<T> | undefined;
}

export function rememberPathProbe(quoteId: string, run: Promise<unknown>): void {
  const id = quoteId.trim();
  probes.set(id, run);
  const drop = () => {
    if (probes.get(id) === run) probes.delete(id);
  };
  run.then(
    () => {
      setTimeout(drop, KEEP_MS);
    },
    () => {
      setTimeout(drop, KEEP_MS);
    },
  );
}

export function invalidatePathProbe(quoteId: string): void {
  probes.delete(quoteId.trim());
}

export function clearPathProbesForTests(): void {
  probes.clear();
}
